import React from "react";
import { Icon, Row, Col, Avatar, Table } from "../../../common/UIComponents";
import { ChevronDownIcon } from "../../../common/CustomIcon";
import BaseList from "../../../components/BaseList";
import moment from "moment";
import AppConfig from "../../../config/AppConfig";

class OrderQuoteActivity extends BaseList {
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: "#",
        key: "index",
        render: (text, record, index) => index + 1,
        width: 55,
      },
      {
        key: "description",
        title: "description",
        dataIndex: "description",
      },
      {
        key: "Date",
        title: "Date",
        dataIndex: "activity_on",
        render: (data) => moment.utc(data).format(AppConfig.dateFormat),
      },
      {
        key: "Created By",
        title: "Created By",
        dataIndex: "activity_by",
      },
    ];

    this.expandIcon = (props) => {
      const { expanded, onExpand, record } = props;

      const hasQuotes = record.quotes !== null;

      if (!hasQuotes) {
        return null;
      }

      return (
        <span
          onClick={(e) => onExpand(record, e)}
          style={{ cursor: "pointer" }}
        >
          {expanded ? (
            <ChevronDownIcon
              color="#313D6B"
              style={{ transform: "rotate(180deg)" }}
            />
          ) : (
            <ChevronDownIcon color="#313D6B" />
          )}
        </span>
      );
    };

    this.expandedRowRender = (record) => {
      const expandedColumns = [
        {
          title: "",
          dataIndex: "description",
        },
        {
          title: "",
          dataIndex: "value",
          align: "right",
        },
      ];

      const expandedData = [];

      if (this.props.orderType === "T") {
        expandedData.push(
          {
            key: "1",
            description: "Pickup Transportation Charges",
            value:
              `$${record.quotes.pickup_transportation_charge.toFixed(
                this.props.decimalPoints
              )}` || this.props.zeroValue,
          },
          {
            key: "2",
            description: "Delivery Transportation Charges",
            value:
              `$${record.quotes.delivery_transportation_charge.toFixed(
                this.props.decimalPoints
              )}` || this.props.zeroValue,
          },

          {
            key: "3",
            description: "Pickup Fuel Charges",
            value:
              `$${record.quotes.pickup_fuel_surcharge.toFixed(
                this.props.decimalPoints
              )}` || this.props.zeroValue,
          },
          {
            key: "4",
            description: "Delivery Fuel Charges",
            value:
              `$${record.quotes.delivery_fuel_surcharge.toFixed(
                this.props.decimalPoints
              )}` || this.props.zeroValue,
          }
        );
      } else {
        expandedData.push(
          {
            key: "1",
            description: "Transportation Charges",
            value:
              `$${record.quotes.transportation_charge.toFixed(
                this.props.decimalPoints
              )}` || this.props.zeroValue,
          },
          {
            key: "2",
            description: "Fuel Charges",
            value:
              `$${record.quotes.fuel_surcharge.toFixed(
                this.props.decimalPoints
              )}` || this.props.zeroValue,
          }
        );
      }

      expandedData.push({
        key: "4",
        description: "Special Charges",
        value:
          `$${record.quotes.additional_charges.toFixed(this.props.decimalPoints)}` || this.props.zeroValue,
      });

      record.quotes.ind_accessorial_charges?.forEach((val, index) => {
        expandedData.push({
          key: `accessorial_${index}`,
          description: val.accessorial_name,
          value:
            `$${val.accessorial_charge.toFixed(this.props.decimalPoints)}` ||
            this.props.zeroValue,
        });
      });

      record.quotes.add_on_details?.forEach((val, index) => {
        expandedData.push({
          key: `add_on_details${index}`,
          description: val.add_on_name,
          value:
            `$${val.add_on_value.toFixed(this.props.decimalPoints)}` ||
            this.props.zeroValue,
        });
      });

      expandedData.push({
        key: "5",
        description: "Total Amount",
        value:
          `$${record.quotes.quote_amount.toFixed(this.props.decimalPoints)}` ||
          this.props.zeroValue,
      });

      return (
        <div style={{ marginTop: "5px" }}>
          <Table
            columns={expandedColumns}
            dataSource={expandedData || []}
            pagination={false}
            showHeader={false}
          />
        </div>
      );
    };
  }

  render() {
    return (
      <Table
        columns={this.columns}
        dataSource={this.props.quote_activities || []}
        expandedRowRender={(record) =>
          record.quotes ? this.expandedRowRender(record) : null
        }
        expandIcon={this.expandIcon}
        rowKey={(record) => record._id}
        pagination={false}
      />
    );
  }
}

export default OrderQuoteActivity;
